import { combineReducers } from 'redux';

import contexts from './Contexto';
import periodos from './Periodos';

export default combineReducers({
    contexts,
    periodos
});